import { render } from "./PublishPost.vue?vue&type=template&id=48b798f1&scoped=true"
import script from "./PublishPost.vue?vue&type=script&lang=js"
export * from "./PublishPost.vue?vue&type=script&lang=js"

import "./PublishPost.vue?vue&type=style&index=0&id=48b798f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b798f1"]])

export default __exports__